import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { dateMiladiToShamsi } from "common/method/date";
import {
  seprateNumberFromComma,
  sepratePriceFromComma,
} from "common/method/seprateNumberFromComma";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const ShowPortfolio = memo(({ tip }) => {
  const classes = useStyles();
  const [stateData, setstateData] = useState([]);
  const [relatedDate, setRelatedDate] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const LastDetailsReducer = useSelector(
    (state) => state.select_last_portfolio_detail_reducer,
  );
  const livePortfolio = useSelector(
    (state) => state.select_live_portfolio_reducer,
  );

  // const optionReducer = useSelector(
  //     (state) => state.select_option_portfolio_reducer
  // );

  useEffect(() => {
    let newState = [];
    if (LastDetailsReducer?.data?.length !== 0) {
      let date = dateMiladiToShamsi(
        LastDetailsReducer?.data[0]?.body.related_date,
      );
      setRelatedDate(date);
      newState = [...newState, ...LastDetailsReducer?.data];
    }

    // if (optionReducer?.data?.length !== 0) {
    //     newState = [...newState, ...optionReducer?.data]
    // }

    setstateData(newState);
  }, [LastDetailsReducer.data]);
  // }, [LastDetailsReducer.data, optionReducer.data]);

  const handledata = (itm, info) => {
    switch (info.type) {
      case "%":
        return (
          <strong
            className="text-xs text-center w-[130px]"
            style={
              handleColorRedGreen(
                itm?.body["quantity"] > 0
                  ? (
                      ((itm?.body["price"] - itm?.body["average_price"]) /
                        itm?.body["average_price"]) *
                      100
                    )?.toFixed(2)
                  : (
                      ((itm?.body["average_price"] - itm?.body["price"]) /
                        itm?.body["average_price"]) *
                      100
                    )?.toFixed(2),
              ) === 1
                ? { color: "#55bc55", cursor: "pointer", direction: "ltr" }
                : handleColorRedGreen(
                      itm?.body["quantity"] > 0
                        ? (
                            ((itm?.body["price"] - itm?.body["average_price"]) /
                              itm?.body["average_price"]) *
                            100
                          )?.toFixed(2)
                        : (
                            ((itm?.body["average_price"] - itm?.body["price"]) /
                              itm?.body["average_price"]) *
                            100
                          )?.toFixed(2),
                    ) === -1
                  ? { color: "#ff0000", cursor: "pointer", direction: "ltr" }
                  : { color: "#000", cursor: "pointer", direction: "ltr" }
            }
          >
            {`${
              itm?.body["quantity"] > 0
                ? (
                    ((itm?.body["price"] - itm?.body["average_price"]) /
                      itm?.body["average_price"]) *
                    100
                  )?.toFixed(2)
                : (
                    ((itm?.body["average_price"] - itm?.body["price"]) /
                      itm?.body["average_price"]) *
                    100
                  )?.toFixed(2)
            } `}
          </strong>
        );

      case "$":
        return (
          <div
            className="text-xs text-center w-[130px]"
            style={{ direction: "ltr" }}
          >
            {seprateNumberFromComma(itm?.body[info["fild"]])}
          </div>
        );
      case "$$":
        return (
          <div
            className="text-xs text-center w-[130px]"
            style={
              handleColorRedGreen(itm?.body["symbol_return"]) === 1
                ? { color: "#55bc55", cursor: "pointer", direction: "ltr" }
                : handleColorRedGreen(itm?.body["symbol_return"]) === -1
                  ? { color: "#ff0000", cursor: "pointer", direction: "ltr" }
                  : { color: "#000", cursor: "pointer", direction: "ltr" }
            }
          >
            <strong>{seprateNumberFromComma(itm?.body[info["fild"]])}</strong> (
            <small>{(itm?.body["symbol_return"] * 100).toFixed(2)}%</small>)
          </div>
        );
      case "stock_type":
        // debugger
        return (
          <div
            className="text-xs text-center w-[130px]"
            style={
              handleColorRedGreen(itm?.body["quantity"]) === 1
                ? { color: "#55bc55", cursor: "pointer", direction: "ltr" }
                : handleColorRedGreen(itm?.body["quantity"]) === -1
                  ? { color: "#ff0000", cursor: "pointer", direction: "ltr" }
                  : { color: "#000", cursor: "pointer", direction: "ltr" }
            }
          >
            {`${itm?.body["quantity"] > 0 ? "خرید" : "فروش"} `}
          </div>
        );
      case "icon":
        return (
          <div className="text-xs text-center w-[130px]">
            {itm?.body[info["icon"]]}
          </div>
        );
      case "name":
        return (
          <div
            className="text-xs text-center w-[130px]"
            // onClick={() => handleClickStock(itm)}
          >
            {itm?.body[info["fild"]]}
          </div>
        );
      default:
        return (
          <div className="text-xs text-center w-[130px]">
            {seprateNumberFromComma(itm?.body[info["fild"]])}
          </div>
        );
    }
  };

  const handleColorRedGreen = (num) => {
    return Math.sign(num);
  };

  // const handelSetAuthority = (isin) => {
  // history.push({
  //   pathname: '/option',
  //   search: '?isin=' + isin
  // })
  // }

  const totalAssets =
    stateData
      ?.filter((item) => item?.body?.quantity > 0)
      ?.map((item) => item?.body?.total_value) || [];

  const sumTotalAssets = totalAssets.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0,
  );

  const totalObligations =
    stateData
      ?.filter((item) => item?.body?.quantity < 0)
      ?.map((item) => item?.body?.total_value) || [];

  const sumTotalObligations = totalObligations.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0,
  );

  const [obligations, setObligations] = useState("");
  const [totalAsset, setTotalAsset] = useState("");

  useEffect(() => {
    if (!livePortfolio?.data?.remain) return;
    const totalAssets = sumTotalAssets + livePortfolio?.data?.remain;
    const totalObligations = sumTotalObligations + livePortfolio?.data?.remain;
    if (livePortfolio?.data?.remain > 0) {
      return setTotalAsset(totalAssets);
    } else if (livePortfolio?.data?.remain < 0) {
      return setObligations(totalObligations);
    }
  }, [livePortfolio?.data?.remain, sumTotalAssets, sumTotalObligations]);

  return (
    <>
      <div className="w-full">
        <div className="flex   items-center flex-wrap gap-3">
          <h1 className="pr-3  mx-2" style={{ width: "max-content" }}>
            نمایش ریز پرتفوی
          </h1>
          {tip && (
            <Tooltip
              style={{ width: "max-content" }}
              className="mt-2"
              title={<p className="p-2 m-0">{tip}</p>}
              placement={isMobile ? "bottom" : "left"}
              arrow
              classes={{ tooltip: classes.tooltip }}
              enterTouchDelay={1}
            >
              <img src="/media/image/Group 12485.png" alt="" />
            </Tooltip>
          )}
          <div
            className="flex flex-wrap gap-4 "
            style={{ width: "max-content" }}
          >
            <div className="flex flex-wrap mx-6 ">
              <p>مجموع دارایی : </p>
              <p className="mr-2 text-green-500">
                {sepratePriceFromComma(totalAsset || sumTotalAssets) || "-"}
              </p>
              <p className="mr-1">ریال</p>
            </div>
            <div
              className="flex flex-wrap mx-6 "
              style={{ width: "max-content" }}
            >
              <p>مجموع تعهدات : </p>
              <p style={{ direction: "ltr" }} className="mr-2 text-red-500">
                {sepratePriceFromComma(obligations || sumTotalObligations) ||
                  "-"}
              </p>
              <p className="mr-1">ریال</p>
            </div>
          </div>
        </div>
        {relatedDate && (
          <div className="text-gray-600 text-sm mr-5">({relatedDate})</div>
        )}
        <div className="w-full  h-full ">
          {stateData?.length > 0 && (
            <div className=" w-full  xl:w-full h-full p-5 flex-col flex overflow-auto ">
              <div className="flex items-center justify-between  bg-gray-200 min-w-[650px]  ">
                {dataTable?.map((itm, ind) => (
                  <div
                    key={ind}
                    className="text-center text-sm text-black p-2 w-full"
                  >
                    <p className="min-w-[60px] ">{itm.name}</p>
                  </div>
                ))}
              </div>
              <div>
                {stateData
                  ?.sort((a, b) => {
                    return b.body.quantity - a.body.quantity;
                  })
                  .map((info, ind) => (
                    <div
                      className={` min-w-[650px] ${
                        ind === stateData?.length - 1 ? "" : "border-b"
                      } flex justify-evenly items-center py-3  ${
                        ind % 2 === 1 ? "bg-gray-50" : ""
                      } `}
                    >
                      {dataTable.map((td, ind2) => (
                        <>
                          {ind2 === 0 ? (
                            <div className="text-center min-w-[50px] text-xs">
                              {ind + 1}
                            </div>
                          ) : (
                            <div
                              style={{ direction: "ltr" }}
                              className="text-center min-w-[50px] text-xs"
                            >
                              {td?.fild && <>{handledata(info, td)}</>}
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default ShowPortfolio;

let dataTable = [
  {
    id: 0,
    name: "ردیف",
    fild: "ind",
    slicePage: 20,
  },
  {
    id: 1,
    name: "موقعیت",
    fild: "stock_type",
    type: "stock_type",
  },
  {
    id: 2,
    name: "نام سهم",
    fild: "stock_short_name",
    type: "name",
  },

  {
    id: 3,
    name: "قیمت فعلی",
    fild: "price",
    type: "$$",
  },
  {
    id: 4,
    name: "میانگین قیمت معامله",
    fild: "average_price",
    type: "$",
  },
  {
    id: 5,
    name: "ارزش کل",
    fild: "total_value",
    type: "$",
  },
  {
    id: 6,
    name: "حجم",
    fild: "quantity",
    type: "$",
  },
  {
    id: 7,
    name: "درصد بازدهی",
    fild: "symbol_return",
    type: "%",
  },
  // {
  //   id: 5,
  //   name: "اختیار",
  //   fild: "",
  //   type: "",
  // },
];
